import React from "react";
import Modal from "./Modal";

type ModalComponentWrapperProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  style?: any;
  canClose?: boolean;
  escapeToClose?: boolean;
  allowClickout?: boolean;
};

export const ModalComponentWrapper = ({
  isOpen,
  onClose,
  children,
  style,
  canClose = true,
  escapeToClose = true,
  allowClickout = true,
}: ModalComponentWrapperProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={style}
      canClose={canClose}
      escapeToClose={escapeToClose}
      allowClickout={allowClickout}
    >
      {children}
    </Modal>
  );
};

